import Sidebar from "../../../components/sidebar/Sidebar";
import SectionContent from "../../../components/sectionContent/sectionContent";
import {Link} from "react-router-dom";
import ConsolidatedBudgetList from "../../../pages/consolidatedbudget/consolidatedBudgetList";
import {filterByClaims, IButtonClaims} from "../../../utils/headerBtnUtils";
import HeaderBtn from "../../../components/headerBtn/headerBtn";
import {IUserOptions} from "../../../types/interfaces";
import {FC, useRef, useState} from "react";
import { useSelector } from "react-redux";

const availableButtons: IButtonClaims[] = [{
    claims: ["analytics:consolidatedbudget:view"],
    component: (
        <HeaderBtn
            content="Сформировать сводный бюджет"
            purpose="consolidatedBudgeExport"
            modalTitle="Сформировать сводный бюджет"
        />
    ),
},
];

const ConsolidatedBudgetInfoSection: FC = () => {

    const {claims} = useSelector((state: IUserOptions) => state.user.user.data);
    const filteredAvailableButtons = availableButtons.filter((btn) => filterByClaims(btn, claims));
    const buttonsContainerRef = useRef<any>(null);
    const [overflowedBtnsCount] = useState<number>(0);
    const [isOpenGroupBtn] = useState<boolean>(false);
    const displayedAvailableBtns = filteredAvailableButtons
        ?.slice(-(overflowedBtnsCount as number))
        ?.map((elem: any, index: number) => {
            return elem && <div key={index}>{elem?.component}</div>;
        });
    const displayedHeadBtns = filteredAvailableButtons
        ?.slice(0, filteredAvailableButtons.length - overflowedBtnsCount)
        ?.map((elem: any, index: number) => {
            return elem && <div key={index}>{elem?.component}</div>;
        });

    return (
        <div className="App">
            <Sidebar/>
            <SectionContent
                section="Сводный бюджет"
                pageName="consolidatedBudget"
                title="Сводный бюджет по проектам"
                buttonsContainerRef={buttonsContainerRef}
                headBlockChildren={displayedHeadBtns}
                isOpenGroupBtn={isOpenGroupBtn}
                availableButtons={displayedAvailableBtns}>
                <div className="content__main">
                    <div className="btns">
                        <Link to="/consolidatedbudget" className="tab">
                            <div className="buttons__btn --active">Сводный бюджет</div>
                        </Link>
                    </div>
                    <ConsolidatedBudgetList/>
                </div>
            </SectionContent>
        </div>
    );
}


export default ConsolidatedBudgetInfoSection;